@if ({ notificationsLoading: notificationsLoading$ | async }; as loadingData) {
  <app-dropdown
    [closeMethod]="closeMethod"
    [title]="'Showing ' + notificationCount + ' notifications'"
  >
    @if (loadingData.notificationsLoading) {
      <app-loading></app-loading>
    }
    @if (!loadingData.notificationsLoading) {
      <div>
        <div class="notifications">
          <div class="body">
            @if ({ notifications: notifications$ | async }; as notifData) {
              @if (notifData.notifications.length > 0) {
                @for (
                  notification of notifData.notifications;
                  track trackByNotificationId($index, notification)
                ) {
                  <app-notification
                    [notification]="notification"
                  ></app-notification>
                }
              } @else {
                <div class="no-notifications">
                  {{
                    "dropdown-notifications.message.no-notifications"
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
    <div class="view-all">
      <a [routerLink]="['analytics', 'notifications']">
        <sui-button variant="primary">
          {{ "dropdown-notifications.button.view-all" | translate }}
        </sui-button>
      </a>
    </div>
  </app-dropdown>
}
